export const showMaxQtyAlert = (): void => {
  alert("Sorry, you've reached the purchase limit for this item.");
};
